import styled from 'styled-components';

export const StyledTextViewModal = styled.div`
  padding: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--color-white);
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  overflow: hidden;
  width: 100%;

  .tvm-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: none;
    padding: 32px 36px 0;

    &-left {
      font-weight: 600;
      font-size: 22px;
      line-height: 33px;
    }

    &-right {
      &-up {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 12px;

        > img {
          width: 52px;
          height: 29px;
          object-fit: contain;
        }
      }
    }
  }

  .tvm-body {
    padding: 12px 36px 0;
    height: 500px;
    overflow-y: auto;
  }

  .tvm-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 36px 36px;

    > button {
      width: auto !important;
      text-transform: capitalize;

      &.prev {
        color: var(--color-medium-gray);
        background: var(--color-light-gray);
      }
    }
  }
`;
